import styled from 'styled-components';
import { rem } from 'polished';
import Icon from '../Icon';

const AccordionDl = styled.dl`
  display: block;
  margin: 0;
  border-bottom: ${rem('2px')} solid ${props => props.theme.colors.grayLighter};
`;
const AccordionDt = styled.dt`
  margin-bottom: 0;
`;

const AccordionDd = styled.dd`
  height: 0;
  opacity: 0;
  overflow: hidden;
  transition: opacity 0.25s ease;
  visibility: hidden;

  ${props =>
    props.active &&
    `
    height: auto;
    opacity: 1;
    visibility: visible;
  `};
`;

const WrapperTitle = styled.span`
  transition: color 0.15s ease;

  ${props =>
    props.active &&
    `
    color: ${props.theme.colors.primary};
  `};
`;

const ButtonAccordion = styled.button`
  align-items: center;
  background: transparent;
  border: 0;
  color: ${props => props.theme.colors.grayDarkest};
  display: flex;
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('16px')};
  padding: 1rem;
  text-align: left;
  width: 100%;

  &:hover,
  &:focus {
    ${WrapperTitle} {
      color: ${props => props.theme.colors.primary};
    }
  }
`;

const IconButton = styled(Icon)`
  fill: ${props => props.theme.colors.primary};
  margin-right: 1rem;
  transform: rotate(-90deg);
  transition: none;

  ${props =>
    props.active &&
    `
    transform: rotate(90deg);
  `};
`;

export {
  AccordionDl,
  AccordionDt,
  AccordionDd,
  ButtonAccordion,
  WrapperTitle,
  IconButton
};
